import React, { useEffect, useState } from "react";
import { Badge, Card,Button, FormControl,InputGroup, OverlayTrigger, Tooltip } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faList,
  faEdit,
  faTrash,
  faStepBackward,
  faFastBackward,
  faStepForward,
  faFastForward,
  faSearch,
  faTimes,
  faEyeLowVision,
  faEye,
  faPeopleRoof,
  faPersonChalkboard,
  faHandsHoldingChild,
  faNewspaper,
  faCircleInfo,
} from "@fortawesome/free-solid-svg-icons";
import { Link, useNavigate } from "react-router-dom";
import MyToast from "../MyToast";
import axios from "axios";
import { debounce } from "lodash";

export default function ReportPage(){
  const url=process.env.REACT_APP_PUBLIC_BACKEND;
  const navigate=useNavigate();
  const [show, setShow]=useState(false);
  const [reports, setReports]=useState([]);
  const [search, setSearch]=useState();
  const [totalElements, setTotalElements]=useState();
  const [totalPages, setTotalPages]=useState();
  const [currentPage, setCurrentPage]=useState(1);
  const [reportsPerPage, setReportsPerPage]=useState(5);
  const [sortDir, setSortDir]=useState("desc");
  const [size, setSize] = useState(() => resolveBreakpoint(window.innerWidth));

  function resolveBreakpoint( width){
    if ( width < 576 ) {
      return 1;
    } else if ( width >= 576 && width < 768 ) {
      return 2;
    } else if ( width >= 768 && width < 992 ) {
      return 3;
    } else if ( width >= 992 && width < 1200 ) {
      return 4;
    } else if ( width >= 1200 && width < 1440 ) {
      return 5;
    } else if ( width >= 1440 ) {
      return 6;
    }
  }

  useEffect(()=> {  
    findAllReports(currentPage);  
  },[]);

  useEffect(() => {
    const calcInnerWidth = debounce(function () {
      setSize(resolveBreakpoint(window.innerWidth));
    }, 200);
    window.addEventListener('resize', calcInnerWidth);
    return () => window.removeEventListener('resize', calcInnerWidth);
  }, []);



function sortData(){
  setTimeout(() => {
    sortDir === "asc"
      ? setSortDir("desc")
      : setSortDir("asc");
    findAllReports(currentPage);
  }, 500);
}
  function findAllReports(currentPage) {
   currentPage -= 1;
    axios
      .get(
        url+"/report/public?pageNumber=" +
          currentPage +
          "&pageSize=" +
          reportsPerPage +
          "&sortBy=date&sortDir=" +
          sortDir
      )
      .then((response) => response.data)
      .then((data) => {
       setReports(data.content);
       setTotalPages(data.totalPages);
       setTotalElements(data.totalElements);
        setCurrentPage(data.number + 1);     
      })
      .catch((error) => {
        console.log(error);
        axios.defaults.headers.Authorization = null;
        navigate("/");
      });
  }

 

  function changePage(event){
    let targetPage = parseInt(event.target.value);
    if (search) {
      searchData(targetPage);
    } else {
        findAllReports(targetPage);
    }
    setCurrentPage(targetPage);
   
  }

  function firstPage(){
    let firstPage = 1;
    if (currentPage > firstPage) {
      if (search) {
        searchData(firstPage);
      } else {
        findAllReports(firstPage);
      }
    }
  }

  function prevPage(){
    let prevPage = 1;
    if (currentPage > prevPage) {
      if (search) {
        searchData(currentPage - prevPage);
      } else {
        findAllReports(currentPage - prevPage);
      }
    }
  }

  function lastPage(){
    let condition = Math.ceil(
      totalElements / reportsPerPage
    );
    if (currentPage < condition) {
      if (search) {
        searchData(condition);
      } else {
        findAllReports(condition);
      }
    }
  }

  function nextPage() {
    if (
      currentPage <
      Math.ceil(totalElements / reportsPerPage)
    ) {
      if (search) {
        searchData(currentPage + 1);
      } else {
        findAllReports(currentPage + 1);
      }
    }
  }

  function searchChange(event){
   setSearch(event.target.value);
  }

  function cancelSearch(){
    setSearch("");
    findAllReports(currentPage);
  }

  function searchData (currentPageIs){
    if(search){
    currentPageIs -= 1;
    axios
      .get(
        url+"/report/public/search/" +
        search +
          "?page=" +
          currentPageIs +
          "&size=" +
          reportsPerPage
      )
      .then((response) => response.data)
      .then((data) => {
        
          setReports(data.content);
          setTotalPages(data.totalPages);
          setTotalElements(data.totalElements);
          setCurrentPage(data.number + 1);
       
    });}
  }
  function linkInst(element){
    if(element==="Kubschütz"){
      return("https://www.feuerwehr-kubschuetz.de");
    }
    else if(element==="BF Bautzen"){
      return("https://www.feuerwehr-bautzen.de/");
    }
    else if(element==="FFW Hochkirch"){
      return("https://www.hochkirch.de/einrichtungen/feuerwehr");
    }
    return("https://www.feuerwehr-kubschuetz.de");
  }

  function createPill(string){
    const arr=string.split(",");
     return( 
      arr.map((element,i)=>(        
        <a  href={linkInst(element)} target="_blank" rel="noreferrer" className="cardtext">
      <Badge key={i} className="pillinst bottompill" pill bg="light" text="dark">
      {element}     
    </Badge>        
    </a>
      ))
     )
  }
function getCatIcon (cat){
if(cat==="Jahreshauptversammlung"){
return(<FontAwesomeIcon icon={faPeopleRoof} />)
}
else if(cat==="Dienstbericht"){
return(<FontAwesomeIcon icon={faPersonChalkboard} />)
}
else if(cat==="Jugendfeuerwehr"){
return(<FontAwesomeIcon icon={faHandsHoldingChild} />)
}
else if(cat==="News"){
return(<FontAwesomeIcon icon={faNewspaper} />)
}
return(<FontAwesomeIcon icon={faCircleInfo} />)
}




  const cardSlides =
      reports.map((card, i) => {
      return ( 
    <div key={i} onClick={() => navigate("/aktuelles/details/"+card.id)}  className={(card.category!==("Info"||"Sonstige")?("report"+card.category):("reportInfo"))+" containerReport containerReportPage"} >

     <div className="dateReport">
     {card.location+", "+new Date(card.date).toLocaleDateString('de-DE')}
     </div>

      <div className="catReport">
      <OverlayTrigger
    placement="top"
    delay={{ show: 250, hide: 400 }}
    overlay={<Tooltip id="button-tooltip">{card.category}</Tooltip>}>
      <Badge pill bg="trasparence" text="dark" className="headpill">
      {getCatIcon(card.category)}
      </Badge>
      </OverlayTrigger>
      </div>

    <div className="ImageReport">
    <img  src={url+"/report/image/download/"+card.id+"/"+card.imageUrl.split(",")[0]} className={"ImgStyleReport"}/>
    </div>

    <div className="titleReport">{card.title}</div>

    <div className="textBegin">{card.report.substring(0,120)+"..."}</div>

    <div className="instiReport">{createPill(card.institutions)}</div>
    </div> 
  );
      })
  
    return (
      <>
      {size>3?(<><br></br><br></br><br></br><br></br></>):null}
      <div id="324" className="ConUni3">
        <div id="34522" className="titleMain">
            <div style={{ float: "left" }}>
              <FontAwesomeIcon icon={faList} /> Übersicht Berichte
            </div>
            <div style={{ float: "right" }}>
            <InputGroup size="sm" style={{ zIndex:'0', padding:'2%', maxWidth: size<4?('170px'):('400px')}}>
                <FormControl
                  placeholder="Search"
                  name="search"
                  value={search}
                  className={"info-border bg-light"}
                  onChange={searchChange}
                  onKeyPress={(e)=>{if(e.key === 'Enter'){searchData(currentPage)}}}
                />
              
                  <Button
                    size="sm"
                    variant="dark"
                    type="button"
                    onClick={searchData(currentPage)}
                  >
                    <FontAwesomeIcon icon={faSearch} />
                  </Button>
                  <Button
                    size="sm"
                    variant="danger"
                    type="button"
                    onClick={cancelSearch}
                  >
                    <FontAwesomeIcon icon={faTimes} />
                  </Button>
               
              </InputGroup>
            </div>
            </div>
            <div id="672" className="MainParty3" style={{padding:"1%"}}>
          {reports?(cardSlides):null}        
          </div>
          {totalElements}
          <div className="footerPageCon">
           
          <div style={{ float: "left", fontSize:"80%", marginLeft: '1.5%'}}>
                Seite {currentPage} von {totalPages}
              </div>
              <div style={{ float: "right" , marginRight: '1.5%',marginLeft: '1.5%'}}>
                <InputGroup size="sm">
               
                    <Button
                      type="button"
                      variant="outline-ligt"
                      disabled={currentPage === 1 ? true : false}
                      onClick={firstPage}
                    >
                      <FontAwesomeIcon icon={faFastBackward} /> Erste
                    </Button>
                    <Button
                      type="button"
                      variant="outline-light"
                      disabled={currentPage === 1 ? true : false}
                      onClick={prevPage}
                    >
                      <FontAwesomeIcon icon={faStepBackward} /> Zurück
                    </Button>
                 
                  <FormControl
                    className={"page-num bg-light"}
                    name="currentPage"
                    value={totalElements}
                    readOnly={true}
                   
                  />
               
                    <Button
                      type="button"
                      variant="outline-light"
                      disabled={currentPage === totalPages ? true : false}
                      onClick={nextPage}
                    >
                      <FontAwesomeIcon icon={faStepForward} /> Nächste
                    </Button>
                    <Button
                      type="button"
                      variant="outline-light"
                      disabled={currentPage === totalPages ? true : false}
                      onClick={lastPage}
                    >
                      <FontAwesomeIcon icon={faFastForward} /> Letze
                    </Button>
                  
                </InputGroup>
              
        </div></div> </div> 
      <br></br>
      <br></br>
      <br></br>
      </>
    );
  }


